import { unsafeCSS, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { BaseElement, customElement } from '../../base-element';
import styles from './segmented-control-item.scss?inline';

@customElement('ps-segmented-control-item')
export class SegmentedControlItemWC extends BaseElement {
  static styles = unsafeCSS(styles);

  /** A unique value used to identify the segment when selected. */
  @property() value = '';

  /** Whether this segment is the active one (set by the parent control). */
  @property({ type: Boolean, reflect: true }) selected = false;

  /** Disables the segment. */
  @property({ type: Boolean, reflect: true }) disabled = false;

  connectedCallback() {
    // eslint-disable-next-line wc/guard-super-call
    super.connectedCallback();
    this.setAttribute('role', 'radio');
  }

  render() {
    return html`
      <button
        type="button"
        class=${classMap({
          'c-segmented-control-item': true,
          'c-segmented-control-item--selected': this.selected,
        })}
        ?disabled=${this.disabled}
        aria-checked=${this.selected ? 'true' : 'false'}
        tabindex=${this.selected ? '0' : '-1'}
      >
        <slot></slot>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-segmented-control-item': SegmentedControlItemWC;
  }
  enum PSElementTagNameMap {
    'ps-segmented-control-item' = 'ps-segmented-control-item',
  }
}
